export default __webpack_public_path__ + "static/media/apple.a7631194.svg";